/*
 * Company Reducer
 */
import {
  GET_COMPANIES,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_ERROR,
  COMPANY_CREATE,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_ERROR,
  COMPANY_EDIT,
  COMPANY_EDIT_SUCCESS,
  COMPANY_EDIT_ERROR,
  COMPANY_DELETE,
  COMPANY_DELETE_SUCCESS,
  COMPANY_DELETE_ERROR,
} from './../actions/Company';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, List, fromJS } from 'immutable';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

/* The initial state of the App */
const CompanyStateRecord = Record({
  isLoading: false,
  actionResponse: null,
  companies: List(),
});

const company = (state = new CompanyStateRecord({}), action) => {
  switch (action.type) {
    case GET_COMPANIES:
      return companyGetAll(state);
    case GET_COMPANIES_SUCCESS:
      return companyGetAllSuccess(state, action);
    case GET_COMPANIES_ERROR:
      return companyGetAllError(state, action);

    case COMPANY_CREATE:
      return companyCreate(state);
    case COMPANY_CREATE_SUCCESS:
      return companyCreateSuccess(state, action);
    case COMPANY_CREATE_ERROR:
      return companyCreateError(state, action);

    case COMPANY_EDIT:
      return companyEdit(state);
    case COMPANY_EDIT_SUCCESS:
      return companyEditSuccess(state, action);
    case COMPANY_EDIT_ERROR:
      return companyEditError(state, action);

    case COMPANY_DELETE:
      return companyDelete(state);
    case COMPANY_DELETE_SUCCESS:
      return companyDeleteSuccess(state, action);
    case COMPANY_DELETE_ERROR:
      return companyDeleteError(state, action);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

const companyGetAll = (state) => {
  return state.setIn(['companies'], state.companies.clear()).setIn(['isLoading'], true);
};

const companyGetAllSuccess = (state, action) => {
  return state
    .setIn(['companies'], fromJS(action.payload.result.companies))
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const companyGetAllError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const companyCreate = (state) => {
  return state.setIn(['isLoading'], true);
};

const companyCreateSuccess = (state, action) => {
  const newList = state.companies.push(fromJS(action.payload.result.company));
  return state
    .setIn(['companies'], newList)
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const companyCreateError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const companyEdit = (state) => {
  return state.setIn(['isLoading'], true);
};

const companyEditSuccess = (state, action) => {
  const newList = state.companies.update(
    state.companies.findIndex((item) => item.get('id') === action.payload.result.company.id),
    (oldItem) => fromJS(action.payload.result.company)
  );
  return state
    .setIn(['companies'], newList)
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const companyEditError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const companyDelete = (state) => {
  return state.setIn(['isLoading'], true);
};

const companyDeleteSuccess = (state, action) => {
  const newList = state.companies.filter(
    (item) => item.get('id') !== action.payload.result.company.id
  );
  return state
    .setIn(['companies'], newList)
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const companyDeleteError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default company;
